import React from 'react';
import { tl } from 'common/services/i18nService';
import * as styles from 'common/components/header/Header.scss';
import { Icon } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import * as moment from 'moment';
import { SIMPLE_DATE_FORMAT_STRING_WITH_SECONDS } from 'common/store/common/constants';
import { RootState } from '../../../../store/rootReducer';

export const SyncInfo: React.FC = React.memo(() => {
    const { assessment } = useSelector((state: RootState) => state);
    const {
        autoSyncValue,
        externalSystem,
        totalNumberOfCandidates,
        totalNumberOfEvaluators,
        committees,
        lastSyncDate,
    } = assessment;
    const lastUpdateMoment = moment.utc(
        lastSyncDate,
        SIMPLE_DATE_FORMAT_STRING_WITH_SECONDS
    );

    return (
        <React.Fragment>
            <div className={styles.syncPopUpHeader}>
                <strong>{tl('grading.header.syncWithFs')}</strong>
                { lastUpdateMoment.isValid() ? (
                    <p>
                        <Icon name="check circle" color="green" />
                        {`${tl('grading.header.lastSync')} ${lastUpdateMoment.fromNow()}.  `}
                    </p>
                ) : null}
            </div>
            <p className={styles.textContent}>
                {autoSyncValue > -1 ? tl('grading.header.autoSync', {
                    externalSystem,
                }) : tl('grading.header.autoSyncDisabled', {
                    externalSystem,
                })}
                <br />
                {`${tl('grading.header.syncData', {
                    numberOfCandidates: totalNumberOfCandidates,
                    numberOfGraders: totalNumberOfEvaluators,
                    numberOfCommittees: committees?.length || 0,
                })}`}
            </p>
        </React.Fragment>
    );
});
